import React, { useState, useEffect } from 'react';
import { Tabs, TabsContent, TabsList, TabsTrigger } from './ui/tabs';
import { getAdditionalServices } from '../api';
import * as LucideIcons from 'lucide-react';

const AdditionalServices = () => {
  const [activeTab, setActiveTab] = useState('kitchen');
  const [additionalServices, setAdditionalServices] = useState({
    kitchen: [],
    bathroom: [],
    rooms: []
  });
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    loadAdditionalServices();
  }, []);

  const loadAdditionalServices = async () => {
    try {
      const response = await getAdditionalServices();
      setAdditionalServices(response.data);
    } catch (error) {
      console.error('Failed to load additional services:', error);
    } finally {
      setIsLoading(false);
    }
  };

  const renderIcon = (iconName) => {
    // Convert icon name to PascalCase for Lucide
    const iconKey = iconName
      .split('-')
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join('');
    const Icon = LucideIcons[iconKey] || LucideIcons.Circle;
    return <Icon className="w-8 h-8 text-orange-600" />;
  };

  return (
    <section className="py-20 bg-gradient-to-b from-gray-50 to-white">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Дополнительные услуги
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            Начните с поддерживающей уборки. Это экономичное решение для
            поддержания порядка. А чтобы учесть все детали, дополнительно выберите
            нужные вам опции из списка ниже.
          </p>
        </div>

        <Tabs defaultValue="kitchen" className="w-full">
          <TabsList className="grid w-full max-w-md mx-auto grid-cols-3 mb-12">
            <TabsTrigger value="kitchen" className="text-base">
              Кухня
            </TabsTrigger>
            <TabsTrigger value="bathroom" className="text-base">
              Санузел
            </TabsTrigger>
            <TabsTrigger value="rooms" className="text-base">
              Комнаты
            </TabsTrigger>
          </TabsList>

          <TabsContent value="kitchen">
            <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
              {additionalServices.kitchen.map((service, index) => (
                <div
                  key={index}
                  className="bg-white p-6 rounded-xl border-2 border-gray-100 hover:border-orange-500 transition-all duration-300 hover:shadow-lg group"
                >
                  <div className="w-16 h-16 bg-gradient-to-br from-orange-50 to-orange-50 rounded-lg flex items-center justify-center mb-4 group-hover:scale-110 transition-transform">
                    {renderIcon(service.icon)}
                  </div>
                  <h3 className="text-lg font-semibold text-gray-900 mb-2">
                    {service.title}
                  </h3>
                  <p className="text-2xl font-bold text-orange-600">
                    {service.price}
                  </p>
                </div>
              ))}
            </div>
          </TabsContent>

          <TabsContent value="bathroom">
            <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
              {additionalServices.bathroom.map((service, index) => (
                <div
                  key={index}
                  className="bg-white p-6 rounded-xl border-2 border-gray-100 hover:border-orange-500 transition-all duration-300 hover:shadow-lg group"
                >
                  <div className="w-16 h-16 bg-gradient-to-br from-orange-50 to-orange-50 rounded-lg flex items-center justify-center mb-4 group-hover:scale-110 transition-transform">
                    {renderIcon(service.icon)}
                  </div>
                  <h3 className="text-lg font-semibold text-gray-900 mb-2">
                    {service.title}
                  </h3>
                  <p className="text-2xl font-bold text-orange-600">
                    {service.price}
                  </p>
                </div>
              ))}
            </div>
          </TabsContent>

          <TabsContent value="rooms">
            <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
              {additionalServices.rooms.map((service, index) => (
                <div
                  key={index}
                  className="bg-white p-6 rounded-xl border-2 border-gray-100 hover:border-orange-500 transition-all duration-300 hover:shadow-lg group"
                >
                  <div className="w-16 h-16 bg-gradient-to-br from-orange-50 to-orange-50 rounded-lg flex items-center justify-center mb-4 group-hover:scale-110 transition-transform">
                    {renderIcon(service.icon)}
                  </div>
                  <h3 className="text-lg font-semibold text-gray-900 mb-2">
                    {service.title}
                  </h3>
                  <p className="text-2xl font-bold text-orange-600">
                    {service.price}
                  </p>
                </div>
              ))}
            </div>
          </TabsContent>
        </Tabs>
      </div>
    </section>
  );
};

export default AdditionalServices;